/*
 * @Author: Liux
 * @Date: 2019-09-24 06:17:29
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:32:51
 */
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';

export enum ButtonIconAlign {
  Left,
  Right,
}

@Component({
  selector: 'ad-button',
  templateUrl: './ad-button.component.html',
  styleUrls: ['./ad-button.component.scss'],
})
export class AdButtonComponent implements OnInit, OnDestroy {
  @Input() type: string = "button";

  @Input() disabled: boolean;

  @Input() style: any;

  @Input() width: string;
  @Input() styleClass: any = { 'btn-primary': true };

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  @Output() onFocus: EventEmitter<any> = new EventEmitter();

  @Output() onBlur: EventEmitter<any> = new EventEmitter();

  @Input() iconClass: string;
  @Input() iconAlign: ButtonIconAlign = ButtonIconAlign.Left;

  constructor() { }
  ngOnDestroy(): void {
    this.onClick.complete();
    this.onClick.unsubscribe();
    this.onClick = null;
  }

  isLeft() {
    return this.iconAlign === ButtonIconAlign.Left;
  }
  ngOnInit() { }
}
